<template>
    <v-menu
        v-model="editing"
        transition="scale-transition"
        :close-on-content-click="false"
        :nudge-width="100"
        :disabled="!allowEditing"
    >
        <template v-slot:activator="{ on }">
            <v-toolbar dense flat color="transparent" class="pa-0">
                <a :class="classTitle" v-on="on" v-text="label"></a>
                <v-spacer />
                <v-icon v-if="isLink" small @click="goToIssue">mdi-open-in-new</v-icon>
            </v-toolbar>
        </template>
        <v-card>
            <v-card-text>
                <v-text-field
                    :label="$t('issues.attributes.supportInput')"
                    v-if="editing"
                    v-model="editingValue"
                    single-line
                ></v-text-field>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="editing = false" v-text="$t('buttons.cancel')" />
                <v-btn color="success" text @click="changeAttribute" v-text="$t('buttons.save')" />
            </v-card-actions>
        </v-card>
    </v-menu>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'issue-support-input',
    data: () => ({
        editing: false,
        editingValue: undefined,
    }),
    props: {
        issue: {},
        allowEditing: {
            default: true,
        },
        onlyEdit: {
            default: false,
        },
    },
    watch: {
        editing: function (e) {
            if (e) {
                this.editingValue = this.issue.supportInput;
            }
        },
    },
    computed: {
        ...mapGetters(['project']),
        classTitle() {
            const clazz = 'blue-grey--text ';
            return this.$vuetify.theme.dark ? clazz + 'text--lighten-4' : clazz + 'text--darken-2';
        },
        isLink() {
            return this.issue.supportInput ? this.issue.supportInput.startsWith('http') : false;
        },
        label() {
            if (this.isLink) {
                return this.$t('issues.actions.supportInputLink');
            } else {
                return this.issue.supportInput ? this.issue.supportInput : '-';
            }
        },
    },
    methods: {
        ...mapActions(['updateIssue']),
        async changeAttribute(value) {
            if (this.onlyEdit) {
                this.$emit('update-attribute', { name: 'supportInput', value: this.editingValue });
                this.editing = false;
            } else {
                await this.updateIssue({
                    id: this.issue.id,
                    supportInput: this.editingValue,
                });

                this.editing = false;
                this.$emit('change-attribute-value');
            }
        },
        goToIssue() {
            window.open(this.issue.supportInput, '_blank');
        },
    },
};
</script>
<style scoped>
.v-toolbar >>> .v-toolbar__content {
    padding: 0px !important;
}
</style>
